import { Badge, Card, Flex, Grid, Link, Text } from '@radix-ui/themes'
import { Link as RouterLink } from '@tanstack/react-router'
import { Ops } from '@willie/schemas'
import { ASSEMBLY_PROFILES, profilesByAssemblyProfile, type InstallationProfileRow } from '../assembly'
import { SkuLinesTable } from './SkuLinesTable'
import { TabHeader } from './TabHeader'

interface AssemblyProfilesTabProps {
  profiles: readonly InstallationProfileRow[]
}

export const AssemblyProfilesTab = ({ profiles }: AssemblyProfilesTabProps) => {
  const profilesByAssembly = profilesByAssemblyProfile(profiles)

  return (
    <Flex direction="column" gap="3">
      <TabHeader>
        Installation profiles with the same SKUs are assembled the same way, so they share an assembly profile.
        Each unit of a SKU becomes its own line of the Efento order.
      </TabHeader>
      <Grid columns={{ initial: '1', md: '2' }} gap="3">
        {ASSEMBLY_PROFILES.map((assemblyProfile) => {
          const usedBy = profilesByAssembly[assemblyProfile]
          return (
            <Card key={assemblyProfile}>
              <Flex direction="column" gap="2">
                <Flex align="center" justify="between" gap="2">
                  <Text size="2" weight="bold" className="font-mono">
                    {assemblyProfile}
                  </Text>
                  {usedBy.length > 0 ? (
                    <Link asChild size="1">
                      <RouterLink to="/installation-profiles" search={{ assembly: assemblyProfile }}>
                        View profiles
                      </RouterLink>
                    </Link>
                  ) : null}
                </Flex>
                <SkuLinesTable lines={Ops.InstallationProfileSkus.assemblyProfileSkuLines(assemblyProfile)} />
                <Flex align="center" gap="1" wrap="wrap">
                  <Text size="1" color="gray">
                    Used by:
                  </Text>
                  {usedBy.length > 0 ? (
                    usedBy.map((profile) => (
                      <Badge key={profile.slug} color="gray" variant="soft" className="font-mono">
                        {profile.slug}
                      </Badge>
                    ))
                  ) : (
                    <Text size="1" color="gray">
                      no installation profile yet
                    </Text>
                  )}
                </Flex>
              </Flex>
            </Card>
          )
        })}
      </Grid>
    </Flex>
  )
}
